export default "__VITE_ASSET__BjPBaeDH__"